const validFileTypes = [
    'image/heic-sequence',
    'image/heif-sequence',
    'image/heif',
    'image/heic',
    'image/jpeg',
    'image/png',
    'image/bmp',
    'image/x-bmp'
];
export const isValidFileType = (fileType) => {
    return validFileTypes.includes(fileType);
};
